@if (loading) {
  <div class="loading-screen">Loading...</div>
} @else {
  <div class="app-layout">
    @if (auth.impersonating) {
      <div class="impersonation-banner">
        <i class="pi pi-eye"></i> You are viewing this portal as a customer (Rep Impersonation Mode)
      </div>
    }
    <app-header></app-header>
    <div class="app-body">
      <app-left-nav></app-left-nav>
      <main class="app-content">
        @if (showLoading) {
          <div class="loading-bar"></div>
        }
        <app-breadcrumb></app-breadcrumb>
        <router-outlet></router-outlet>
      </main>
      <app-right-panel></app-right-panel>
    </div>
    <app-upload-status></app-upload-status>
    <p-confirmDialog></p-confirmDialog>
  </div>
}
